module.exports = __webpack_public_path__ + "assets/img/rule.056df403.png";